import { SET_DOWNLOAD_INFO } from '../mutation-types'
import Vue from 'vue'
import { matchPlatform } from '../../lib/matchPlatform'

const state = {
  windows: {
    // qt
    downloadInfo: {
      download_link: '',
      platform: 'windows',
      version_name: ''
    },
    name: 'Windows',
    support: 'Windows 7/8/10/11',
    imgUrl: '/static/img/downloadBanner/windows.png'
  },
  windowsWpf: {
    // .net
    downloadInfo: {
      download_link: '',
      platform: 'windows',
      version_name: ''
    },
    name: 'Windows',
    support: 'Windows 7/8/10',
    imgUrl: '/static/img/downloadBanner/windows.png'
  },
  mac: {
    downloadInfo: {
      download_link: '',
      platform: 'mac',
      version_name: ''
    },
    name: 'Mac',
    imgUrl: '/static/img/downloadBanner/mac.png',
    support: 'macOS 10.12+'
  },
  ios: {
    downloadInfo: {
      download_link: '',
      platform: 'ios',
      version_name: ''
    },
    name: 'iOS',
    imgUrl: '/static/img/downloadBanner/ios.png',
    support: 'iOS 11+'
  },
  android: {
    downloadInfo: {
      download_link: '',
      platform: 'android',
      version_name: ''
    },
    name: 'Android',
    imgUrl: '/static/img/downloadBanner/android.png',
    support: 'Android 5.0+'
  },
  androidTV: {
    downloadInfo: {
      download_link: '',
      platform: 'androidTV',
      version_name: ''
    },
    name: 'Android TV',
    support: 'Android 5.0+',
    imgUrl: '/static/img/downloadBanner/androidTV.png'
  },
  ubuntu: {
    downloadInfo: {
      download_link: '',
      platform: 'ubuntu',
      version_name: ''
    },
    name: 'Ubuntu',
    imgUrl: '/static/img/downloadBanner/linux.png',
    support: 'Ubuntu LTS 16.04+'
  },
  allDownloadInfo: {},
  currentPlatform: 'windows',
  platform: matchPlatform()
}

const mutations = {
  setCurrentPlatform (state, platform) {
    state.currentPlatform = platform
  },
  [SET_DOWNLOAD_INFO] (state, data) {
    state.windows.downloadInfo = data.windows
    state.windowsWpf.downloadInfo = data.windows_wpf
    state.windowsWpf.downloadInfo.version_name = '3.0.34'
    state.mac.downloadInfo = data.macos
    state.ios.downloadInfo = data.ios
    state.android.downloadInfo = data.android
    state.androidTV.downloadInfo = data['android-tv']
    state.ubuntu.downloadInfo = data.linux
    state.allDownloadInfo = data
  }
}

const actions = {
  getDownloadInfo ({commit}) {
    return new Promise(function (resolve, reject) {
      Vue.http.get('api/installation-packages').then((response) => {
        if (response.data.code === 0) {
          resolve(response)
          commit(SET_DOWNLOAD_INFO, response.body.data)
        }
      })
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/download.js